import { render, staticRenderFns } from "./oauth2.vue?vue&type=template&id=d1840d5a&scoped=true&"
import script from "./oauth2.vue?vue&type=script&lang=ts&"
export * from "./oauth2.vue?vue&type=script&lang=ts&"
import style0 from "./oauth2.vue?vue&type=style&index=0&id=d1840d5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1840d5a",
  null
  
)

export default component.exports